import { render, staticRenderFns } from "./TwoImages.vue?vue&type=template&id=018f1941&scoped=true"
import script from "./TwoImages.vue?vue&type=script&lang=js"
export * from "./TwoImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018f1941",
  null
  
)

export default component.exports